import React, { useCallback, useEffect, useState } from 'react';

import { ExtraItemEnum } from 'enums';
import { CompanySelectModel } from 'api/adminApiClient';
import { getSelectedFilterValues } from 'utils/filterUtils';
import { TimesheetStatusReportFilterTypes } from '../enums';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';
import { getMembersForAdminTimesheetStatusReport } from 'redux/reducers/homeDashboardSlice';
import { TimesheetStatusReportFilters } from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/TimesheetStatusReportFilter';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  filters: TimesheetStatusReportFilters;
  onChange: (data: TimesheetStatusReportFilters) => void;
};

export default function MemberFilter(props: Props) {
  const { filters, onChange } = props;
  const dispatch = useAppDispatch();
  const [members, setMembers] = useState<CompanySelectModel[]>([]);
  const [isMembersLoaded, setIsMembersLoaded] = useState(false);

  const loadMembers = useCallback(async () => {
    const result = await dispatch(getMembersForAdminTimesheetStatusReport());

    if (getMembersForAdminTimesheetStatusReport.fulfilled.match(result)) {
      setMembers(result.payload);
    }
    setIsMembersLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadMembers();
  }, [loadMembers]);

  const handleFilterChange =
    (type: TimesheetStatusReportFilterTypes) => (members: string[]) => {
      const selectedFilterValues = getSelectedFilterValues(
        members,
        ExtraItemEnum.All,
      );

      onChange({
        ...filters,
        [type]: selectedFilterValues,
      });
    };

  return (
    <SelectWithLoading
      isLoading={!isMembersLoaded}
      optionLabelProp="label"
      className="full-width"
      value={filters[TimesheetStatusReportFilterTypes.Member]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a member"
      onChange={handleFilterChange(TimesheetStatusReportFilterTypes.Member)}
      showSearch
      data-id="memberFilterField"
    >
      {isMembersLoaded && (
        <>
          <SelectWithLoading.Option
            key={ExtraItemEnum.All}
            value={ExtraItemEnum.All}
          >
            <div>
              <div>{ExtraItemEnum.All}</div>
            </div>
          </SelectWithLoading.Option>
          {members.map(({ companyId, companyName, memberKey }) => (
            <SelectWithLoading.Option
              key={companyId}
              value={companyId || ''}
              label={companyName}
            >
              {`${companyName} ${memberKey}`}
            </SelectWithLoading.Option>
          ))}
        </>
      )}
    </SelectWithLoading>
  );
}
